// CompanyIcon.tsx
import React from 'react';
import styled from 'styled-components';
import { BiBuildingHouse } from 'react-icons/bi';

// Style the wrapper
const StyledIconWrapper = styled.div`
  width: 30px;
  height: 30px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  transition: fill 0.2s ease;

  svg {
    width: 100%;
    height: 100%;
    color: #ffffff;
  }
`;

// Type BiBuildingHouse as a proper React component
const TypedBiBuildingHouse = BiBuildingHouse as unknown as React.FC<{ size?: number | string }>;

const CompanyIcon: React.FC = () => (
  <StyledIconWrapper>
    <TypedBiBuildingHouse size={24} />
  </StyledIconWrapper>
);

export default CompanyIcon;